// src/components/ProtectedLayout.tsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import Layout from './Layout';
import { MessagingProvider } from '../contexts/MessagingContext';

const ProtectedLayout: React.FC = () => {
  return (
    <MessagingProvider>
      <Layout>
        <Outlet />
      </Layout>
    </MessagingProvider>
  );
};

export default ProtectedLayout;
